export const getJaneGoldFormattedLabel = (
  label?: number,
  noSign?: boolean
): string =>
  `${noSign ? '' : '+ '}${label?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })}`;
